import { BaseService } from './BaseService'
import {
  ScoutAccountsResponse,
  ScoutAccountResponse,
  ScoutScanStatusResponse
} from '../types/scout'

class ScoutAccountService extends BaseService {
  constructor() {
    super('cro')
  }

  async getAccounts(
    customerId: string,
    page?: number,
    limit?: number,
    // owned=false → competitors (Brand Scout page); owned=true → owned+partner (Content
    // Performance); omit → all. Owned/partner accounts are auto-created from the social scrape.
    owned?: boolean
  ): Promise<ScoutAccountsResponse> {
    return this.get<ScoutAccountsResponse>('/scout/accounts', {
      customerId,
      page,
      limit,
      ...(owned !== undefined ? { owned } : {})
    })
  }

  async createAccount(
    customerId: string,
    username: string,
    platformId: number = 1
  ): Promise<ScoutAccountResponse> {
    return this.post<ScoutAccountResponse>(
      '/scout/accounts',
      { username, platformId },
      { customerId }
    )
  }

  async updateAccount(
    id: string,
    customerId: string,
    updates: { is_active?: boolean; display_name?: string }
  ): Promise<ScoutAccountResponse> {
    return this.put<ScoutAccountResponse>(
      `/scout/accounts/${id}`,
      updates,
      { customerId }
    )
  }

  async getScanStatus(
    scanId: string,
    customerId: string
  ): Promise<ScoutScanStatusResponse> {
    return this.get<ScoutScanStatusResponse>(`/scout/accounts/scans/${scanId}/status`, {
      customerId
    })
  }

  async deleteAccount(
    id: string,
    customerId: string
  ): Promise<{ success: boolean; message: string }> {
    return this.delete<{ success: boolean; message: string }>(
      `/scout/accounts/${id}`,
      { customerId }
    )
  }
}

export const scoutAccountService = new ScoutAccountService()
export default scoutAccountService
